console.log('✅ login-user-options-top.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, watchAppState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

//let _tempTextTranslator = null;
//export async function initTempTextTranslator(lang) {
//    _tempTextTranslator = await loadTextTranslations(lang);
//}

//let _tempLinksTranslator = null;
//export async function initTempLinksTranslator(lang) {
//    _tempLinksTranslator = await initLinksTranslator(lang);
//}

export async function buildComponentLoginUserOptionsTop() {
  console.log(`🔄 Building Component: LoginUserOptionsTop - lang: ${appState.SiteLanguageCookie}`);

    try {


    let htmlToRender = '';

    if (isNodeEnvironment()) {
      htmlToRender = await buildActualContent();
    } else {
      htmlToRender = await buildPageSkeleton();
    }

    const html = `
      


    ${htmlToRender}

      


        `;

    

    // Register event listeners
    registerEventListenerToAttach(async () => initComponentLoginUserOptionsTop());

    return html;
  } catch (err) {
    console.error('❌ Error building LoginUserOptionsTop:', err);
    return '<div>Error loading user options</div>';
  }
}

export async function initComponentLoginUserOptionsTop() {
  try {
    //  alert("1 Logged in User: " + appState.MyUserIsAuthenticated);

    let htmlToRender = await buildActualContent();

    const currentPlacholder = document.querySelector(
      '#placeholder-buildComponentLoginUserOptionsTop'
    );
    if (currentPlacholder) {
      currentPlacholder.innerHTML = htmlToRender;
    }

    const dropdown = document.querySelector('#TopLoginUserMenu');

    const wrapperDiv = document.querySelector('.TopLoginUserOptionsWrapper');

    const toggleButton = document.querySelector('#TopLoginUserToggle');

    if (!dropdown) {
      console.warn('⚠️ Some required elements not found, skipping LoginUserOptionsTop setup.');
      return;
    }

    if (!toggleButton) {
      alert('toogle not found');
      console.warn('⚠️ Some required elements not found, skipping LoginUserOptionsTop setup.');
      return;
    }

    let isDropdownOpen = false;

    const toggleDropdownHandler = async () => {
      isDropdownOpen = !isDropdownOpen;
      dropdown.style.display = isDropdownOpen ? 'block' : 'none';

      if (isDropdownOpen) {
        // to do maybe revalidedate access
        //  console.log("🌐 Populating currencies on dropdown open");
        //   await populateCurrencyDropdown();
        //  currencyDropdown.value = appState.SiteCurrencyCodeCookie || "USD";
        // txtExchangeRate.value = appState.SiteCurrencyRateCookie || "1.00";
        // setExchangeRate();
      }
    };

    const closeDropdownHandler = () => {
      isDropdownOpen = false;
      dropdown.style.display = 'none';
    };

    // Safely remove existing listeners first
    toggleButton.removeEventListener('click', toggleDropdownHandler);
    toggleButton.addEventListener('click', toggleDropdownHandler);

    document.removeEventListener('click', closeDropdownHandler);
    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target) && !toggleButton.contains(event.target)) {
        closeDropdownHandler();
      }
    });

    // Links inside panel that should close the panel when clicked
    const closeOnClickLinks =
      document.getElementById('TopLoginUserMenu')?.querySelectorAll('[data-close-on-click]') || [];

    closeOnClickLinks.forEach(link => {
      const onLinkClick = () => closeDropdownHandler();
      link.removeEventListener('click', onLinkClick);
      link.addEventListener('click', onLinkClick);
    });

    console.log('✅ LoginUserOptionsTop event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to LoginUserOptionsTop:', error);
  }
}

export async function buildPageSkeleton() {
  const frame = await buildLoggedOutView();

  let html = `

    <div id="placeholder-buildComponentLoginUserOptionsTop">

    ${frame}

    </div>`;

  return html;
}

export async function buildActualContent() {
  let html = '';

  if (appState.MyUserIsAuthenticated) {
    html = await buildLoggedInView();
  } else {
    html = await buildLoggedOutView();
  }

  return html;
}

async function buildLoggedInView() {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyOnBehalfOf: lblOnBehalfOf,
    keyHello: lblHello,
    keySellerDashboard: lblSellerDashboard,
    keyStoreOrders: lblStoreOrders,
    keyMyProducts: lblMyProducts,
    keyMyCompanies: lblMyCompanies,
    keyDashboard: lblDashboard,
    keyMyDetails: lblMyDetails,
    keyMyOrders: lblMyOrders,
    keyMyAddresses: lblMyAddresses,
    keyMyPaymentMethods: lblMyPaymentMethods,
    keyChangeProfile: lblChangeProfile,
    keyLogout: lblLogout,
  } = _tempTextTranslator;

  const {
    keyMyStore: linkMyStore,
    keyStoreOrders: linkStoreOrders,
    keyMyProducts: linkMyProducts,
    keyMyCompanies: linkMyCompanies,
    keyDashboard: linkDashboard,
    keyMyDetails: linkMyDetails,
    keyMyOrders: linkMyOrders,
    keyMyAddresses: linkMyAddresses,
    keyMyPaymentMethods: linkMyPaymentMethods,
    keySelectProfile: linkSelectProfile,
    keyLogout: linkLogout,
  } = _tempLinksTranslator;

  let html = '';

  if (appState.MyUserIsAuthenticated) {
    // logged‐in dropdown
    html = `
      <div class="TopLoginUserOptionsWrapper" tabindex="0">

        <div id="TopLoginUserToggle" class="divTopUserOptionsWrapper-Button">
          ${lblHello}, ${appState.MyUserFirstName} ${appState.MyUserLastName}

          ${
        appState.MyBuyingEntityType === 'Business'  ? `${lblOnBehalfOf} ${appState.MyBuyingEntityCompanyName}`
              : ''
          }

          <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="TopLoginUserOptionsToggleIcon-svg">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>    </svg>
        </div>

        <div id="TopLoginUserMenu" class="dropdownLoggedInUser-content" style="display: none;">
          ${
            appState.MyBuyingEntityType === 'Business'
              ? `  <a data-close-on-click href="${linkMyStore}">${lblSellerDashboard}</a>
               <a data-close-on-click href="${linkStoreOrders}">${lblStoreOrders}</a>
               <a data-close-on-click href="${linkMyProducts}">${lblMyProducts}</a>
               <a data-close-on-click href="${linkMyCompanies}">${lblMyCompanies}</a>
               <a data-close-on-click href="${linkSelectProfile}">${lblChangeProfile}</a>
               
               `
              : `  <a data-close-on-click href="${linkDashboard}">${lblDashboard}</a>
               <a data-close-on-click href="${linkMyDetails}">${lblMyDetails}</a>
               <a data-close-on-click href="${linkMyOrders}">${lblMyOrders}</a>
               <a data-close-on-click href="${linkMyAddresses}">${lblMyAddresses}</a>
               <a data-close-on-click href="${linkMyPaymentMethods}">${lblMyPaymentMethods}</a>
               <a data-close-on-click href="${linkSelectProfile}">${lblChangeProfile}</a>
               
               `
          }
          ${
            appState.UserHasAtLeastOneBuyingCompanyAccess
              ? `<a data-close-on-click href="${linkSelectProfile}">${lblChangeProfile}</a>`
              : ''
          }


          <a data-close-on-click href="${linkLogout}">${lblLogout}</a>
        </div>
      </div>
    `;
  } else {
    // logged‐out links
    html = await buildLoggedOutView();
  }

  return html;
}

async function buildLoggedOutView() {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const { keySignIn: textkeySignIn, keyRegister: textkeyRegister } = _tempTextTranslator;

  const { keyRegister: linkKeyRegister, keySignIn: linkKeySignIn } = _tempLinksTranslator;

  const html = `
            <div class="loggedOutTopTextFormat">
                <a href="${linkKeySignIn}" class="loginUserOptionsLink"> ${textkeySignIn}</a>
                <a href="${linkKeyRegister}" class="btnTopSignIn-RegisterBtn"> ${textkeyRegister}</a>
            </div>
        `;

  return html;
}


async function refreshWholeComponent(isAuthenticated) {

    //   alert(`updateHeaderForUser called with isAuthenticated: ${isAuthenticated}`);

    await buildComponentLoginUserOptionsTop();
    await initComponentLoginUserOptionsTop();


}


let IsAttachedWatchAppState = false;

if (!IsAttachedWatchAppState) {
    watchAppState('MyUserIsAuthenticated', refreshWholeComponent);
    IsAttachedWatchAppState = true;
}
